import React from "react";
import clsx from "clsx";
import * as Icons from "../../ui/shared/Icons";

interface Props {
  styles?: string;
  placeholder?: string;
  onSearchChange?: (value: string) => void;
  value?: string;
}

const Search: React.FC<Props> = ({ styles = "w-[417px] min-h-[40px]", placeholder, onSearchChange, value }: Props) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onSearchChange) {
      onSearchChange(e.target.value);
    }
  };

  return (
    <div
      className={clsx(
        "gap-2 rounded-[12px] border border-border bg-white px-3 flex justify-start items-center shadow-sm transition-all duration-200 focus-within:border-[#2563EB] focus-within:ring-2 focus-within:ring-[#2563EB]/20 dark:rounded-[6px] dark:border-neutral-500 dark:bg-neutral-600 dark:shadow-none dark:focus-within:ring-0",
        styles
      )}
    >
      <Icons.search className="w-[16px] h-[16px] text-muted-foreground dark:text-neutral-400" />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        className="grow-1 text-[16px] font-normal text-foreground placeholder:text-muted-foreground w-full h-full border-none focus:outline-none bg-transparent dark:text-neutral-50 dark:placeholder:text-neutral-400"
      />
    </div>
  );
};

export default Search;
